export default __webpack_public_path__ + "static/media/boat.ac7e5cb1.svg";